import { useEffect, useRef, useState } from 'react';
import { decodeToken, logout, refreshToken } from '../../utilities/auth';
import InactivityModal from '../common/InactivityModal';
import UnauthorizedModal from '../common/UnauthorizedModal';
import { useIdleTimer } from 'react-idle-timer';
import { Outlet, useLocation } from 'react-router-dom';

const SessionHOC = ({ loginURL = '/login', referralURL = '/referrals' }) => {
  const [showSessionModal, setShowSessionModal] = useState(false);
  const [showUnauthorizedModal, setShowUnauthorizedModal] = useState(false);
  const unauthorizedModalRef = useRef(false);
  const location = useLocation();

  const onPrompt = () => {
    if (unauthorizedModalRef.current) {
      setShowSessionModal(false);
      return;
    }
    if (decodeToken('da')) {
      setShowSessionModal(true);
    } else {
      setShowSessionModal(false);
    }
  };

  const onAction = () => {
    if (unauthorizedModalRef.current) {
      setShowSessionModal(false);
      return;
    }
    if (decodeToken('da')) {
      if (Math.ceil(getRemainingTime() / 1000) <= 295 && !showSessionModal) {
        // handleRefresh();
      }
    }
  };

  const onIdle = () => {
    if (unauthorizedModalRef.current) {
      setShowSessionModal(false);
      return;
    }
    if (decodeToken('da')) {
      setShowSessionModal(false);
      if (location.pathname.startsWith('/portal')) {
        logout(loginURL);
      } else if (location.pathname.startsWith('/referrals')) {
        logout(referralURL);
      } else {
        logout(loginURL);
      }
    } else {
      setShowSessionModal(false);
    }
  };
  const { reset, getRemainingTime } = useIdleTimer({
    timeout: 1000 * 60 * 5,
    onIdle,
    promptBeforeIdle: 1000 * 60 * 1,
    onPrompt,
    onAction
  });

  const handleReset = () => {
    reset();
    setShowSessionModal(false);
  };

  const handleRelogin = () => {
    if (location.pathname.startsWith('/referrals')) {
      logout(referralURL);
      return;
    }
    logout(loginURL);
  };

  useEffect(() => {
    const initialTimer = decodeToken('timer', '/portal', false);
    if (!initialTimer) {
      refreshToken();
    }

    const inter = setInterval(
      () => {
        const expiryTime = decodeToken('timer', '/portal', false);
        const currentTime = Date.now();

        if (expiryTime) {
          const timeLeft = Number(expiryTime) - currentTime;
          // Less than 2 minutes to expiry ⇒ trigger refresh
          if (timeLeft < 2 * 60 * 1000) {
            refreshToken();
          }
        }
      },
      1 * 60 * 1000
    ); // Check every 1 minute

    return () => {
      clearInterval(inter);
    };
  }, []);

  useEffect(() => {
    unauthorizedModalRef.current = showUnauthorizedModal;
  }, [showUnauthorizedModal]);

  useEffect(() => {
    const handleUnauthorized = () => {
      setShowSessionModal(false);
      setShowUnauthorizedModal(true);
    };

    window.addEventListener('alatpay:unauthorized', handleUnauthorized);
    return () => {
      window.removeEventListener('alatpay:unauthorized', handleUnauthorized);
    };
  }, []);

  return (
    <>
      {showSessionModal && !showUnauthorizedModal && (
        <InactivityModal
          inactivityModal={showSessionModal}
          handleAction={handleReset}
          setInactivityModal={setShowSessionModal}
          timeLeft={Math.ceil(getRemainingTime() / 1000)}
          logoutPath={
            location.pathname.startsWith('/referrals') ? referralURL : loginURL
          }
        />
      )}
      <UnauthorizedModal
        open={showUnauthorizedModal}
        onReLogin={handleRelogin}
        title="Session Verification Required"
        body="We are unable to verify your session at the moment. Please sign in again to continue using the platform securely."
      />
      <Outlet />
    </>
  );
};

export default SessionHOC;
